import script from "./HomePointComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePointComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomePointComponent.vue?vue&type=style&index=0&id=e513baae&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e513baae"]])

export default __exports__